import HttpService from './http.service';

class UserService {
  getUsers(params) {
    return HttpService.get('users', {
      params,
    })
      .then((res) => res.data);
  }

  getUsersGroups() {
    return HttpService.get('users/groups')
      .then((res) => res.data);
  }

  getUser(id) {
    return HttpService.get(`users/${id}`)
      .then((res) => res.data);
  }

  generateUserPassword(id) {
    return HttpService.get(`users/generateNewPassword/${id}`)
      .then((res) => res.data);
  }

  createUser(user) {
    return HttpService.post('users', user)
      .then((res) => res.data);
  }

  updateUser(user) {
    return HttpService.patch(`users/${user.id}`, user)
      .then((res) => res.data);
  }

  deleteUser(user) {
    return HttpService.delete(`users/${user.id}`)
      .then((res) => res.data);
  }

  suggestUsers(params) {
    return HttpService.get('users/suggestions', { params })
      .then((res) => res.data);
  }
}

export default new UserService();
